module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "action-sheet-view"
  }, [_c('VwButton', {
    attrs: {
      "plain": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.actionSheet('iOS')
      }
    }
  }, [_vm._v("iOS")]), _vm._v(" "), _c('VwButton', {
    attrs: {
      "plain": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.actionSheet('noCancel')
      }
    }
  }, [_vm._v("No cancel")]), _vm._v(" "), _c('VwButton', {
    attrs: {
      "plain": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.actionSheet('Android')
      }
    }
  }, [_vm._v("Android")]), _vm._v(" "), _c('ActionSheet', {
    attrs: {
      "show-it": _vm.iOS
    },
    on: {
      "hide": _vm.hidePopup
    }
  }, [_c('div', [_vm._v("选项1")]), _vm._v(" "), _c('div', [_vm._v("选项2")]), _vm._v(" "), _c('div', [_vm._v("选项3")])]), _vm._v(" "), _c('ActionSheet', {
    attrs: {
      "show-it": _vm.noCancel,
      "no-cancel": ""
    },
    on: {
      "hide": _vm.hidePopup
    }
  }, [_c('div', [_vm._v("选项1")]), _vm._v(" "), _c('div', [_vm._v("选项2")]), _vm._v(" "), _c('div', [_vm._v("选项3")])]), _vm._v(" "), _c('ActionSheet', {
    attrs: {
      "android": "",
      "show-it": _vm.Android
    },
    on: {
      "hide": _vm.hidePopup
    }
  }, [_c('div', [_vm._v("选项1")]), _vm._v(" "), _c('div', [_vm._v("选项2")]), _vm._v(" "), _c('div', [_vm._v("选项3")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-42c9be3c!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/actionSheetView.vue
// module id = 235
// module chunks = 0